/* RESPONSIBLE TEAM: team-inbox */

import TruncateString from 'embercom/lib/truncate-string';

export const MAX_EVENT_NAME_LENGTH = 25;
export const FEATURE_FLAG_NAME = 'conversation-events-ui-improvements';

/**
 * Truncates text to MAX_EVENT_NAME_LENGTH characters with ellipsis
 */
export function truncateEventText(text: string | undefined | null): string {
  if (!text) {
    return '';
  }
  return TruncateString(text, MAX_EVENT_NAME_LENGTH, true);
}

/**
 * Checks if text exceeds MAX_EVENT_NAME_LENGTH and would be truncated
 */
export function isEventTextTruncated(text: string | undefined | null): boolean {
  if (!text) {
    return false;
  }
  return text.length > MAX_EVENT_NAME_LENGTH;
}
